import { useState } from 'react';
import { insightsData } from '../../../mocks/insights';

export default function Insights() {
  const [activeFilter, setActiveFilter] = useState('전체');

  const filters = ['전체', '면접 준비', '이력서', '커리어 전환', '업계 인사이트'];

  const filteredArticles =
    activeFilter === '전체'
      ? insightsData
      : insightsData.filter((article) => article.category === activeFilter);

  return (
    <section id="insights" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-12">
          <h2 className="text-5xl font-bold text-gray-900 mb-6 md:mb-0">Insights</h2>

          <div className="flex flex-wrap gap-3">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeFilter === filter
                    ? 'bg-teal-500 text-white shadow-md'
                    : 'bg-white text-gray-700 border border-gray-300 hover:border-teal-500'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredArticles.map((article) => (
            <article
              key={article.id}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `url('${article.image}')` }}
              ></div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-xs font-medium rounded-full mb-3">
                  {article.category}
                </span>
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">{article.summary}</p>
                <div className="flex items-center justify-between text-xs text-gray-500">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="inline-flex items-center space-x-2 bg-gray-900 text-white px-8 py-4 rounded-lg font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
            <span>더 보기</span>
            <i className="ri-arrow-down-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
